import HeaderView from './Header';
import FooterView from './Footer';
import PriceRevealView from './PriceReveal';
import HomeView from './Home';
import LoginView from './Login';
import MenuView from './Menu';
import HelpView from './Help';
export * from './Trades';
export * from './PlayerComparison';
import GameSelectorView from './GameSelector';
import ActivateGameView from './ActivateGame';
import CoachPopup from './CoachPopup';
import OnboardingView from './Onboarding';

export * from './StatsCentre';
export * from './StatsCentre/StatsCentrePlayerPool';
export * from './StatsCentre/StatsCentrePlayerPoolList';

export * from './MatchCentre';
export * from './MatchCentre/MatchCentreControls';
export * from './MatchCentre/MatchCentreMatchSelect';
export * from './MatchCentre/MatchCentreHeading';
export * from './MatchCentre/MatchCentreInfoBar';
export * from './MatchCentre/MatchCentrePlayersPool';

export * from './MatchCentreLanding';
export * from './MatchCentreLanding/MatchCentreDays';
export * from './MatchCentreLanding/MatchCentreDay';
export * from './MatchCentreLanding/MatchCentreMatches';
export * from './MatchCentreLanding/MatchCentreMatch';



import {
	PasswordChangeView,
	PasswordChangeConfirmationView,
} from './Password';

import {
	LeagueCreateView,
	LeagueSettingsView,
	LeagueJoinView,
	LeagueCongratulationView,
	LeagueInvitesView,
	leagueJoinBar,
	MyLeagueTableView,
	RegenerationBarView,
	JoinFilterView,
	RegenerateLeagueTableView,
	RegenerationRestartView,
	RegenerationInviteView,
	LeagueFixturesView,
	LadderTable,
	LadderTeamRow,
	LadderHeader
} from './League';

import {
	AccountSettings,
	CommunicationsView,
	CoachView,
	CoachHeaderView,
	CoachDescriptionView,
	CoachSubscriptionTypeView,
	CoachFeaturesView,
	CoachFormTableView,
} from './Account';

export * from './Fantasy';
export * from '../../../core/views';
export * from './Rankings';
export * from './League/MatchUp';
export * from './League/MatchUp/MatchUpHeader';
export * from './League/MatchUp/MatchUpUsers';
export * from './ViewOthersTeams';
export * from './PlayerProfile';
export * from './OffSeason';
export * from './MatchCentreGameBar';
export * from './FantasyCoach';

export { HeaderView };
export { FooterView };
export { MenuView };

export {
	LeagueCreateView,
	LeagueSettingsView,
	LeagueJoinView,
	LeagueCongratulationView,
	LeagueInvitesView,
	leagueJoinBar,
	MyLeagueTableView,
	LeagueFixturesView,
	LadderTable,
	LadderTeamRow,
	LadderHeader
}

export {
	RegenerateLeagueTableView,
	RegenerationRestartView,
	RegenerationInviteView,
	RegenerationBarView
};

export { PriceRevealView };
export { JoinFilterView };
export { HomeView };
export { LoginView };
export { GameSelectorView };
export { ActivateGameView };

export { PasswordChangeView };
export { PasswordChangeConfirmationView };

export { AccountSettings };
export { CommunicationsView };
export { CoachView };
export { CoachHeaderView };
export { CoachDescriptionView };
export { CoachSubscriptionTypeView };
export { CoachFeaturesView };
export { CoachFormTableView };
export { HelpView };
export { CoachPopup };
export { OnboardingView };

export default {
	HeaderView,
	FooterView,
	MenuView,
	LeagueCreateView,
	LeagueSettingsView,
	LeagueJoinView,
	LeagueCongratulationView,
	LeagueInvitesView,
	PriceRevealView,
	leagueJoinBar,
	MyLeagueTableView,
	RegenerationBarView,
	JoinFilterView,
	RegenerateLeagueTableView,
	RegenerationRestartView,
	RegenerationInviteView,
	HomeView,
	LoginView,
	AccountSettings,
	HelpView,
	CommunicationsView,
	GameSelectorView,
	ActivateGameView,
	PasswordChangeView,
	PasswordChangeConfirmationView,
	CoachPopup,
	CoachView,
	CoachHeaderView,
	CoachDescriptionView,
	CoachSubscriptionTypeView,
	CoachFeaturesView,
	CoachFormTableView,
	LeagueFixturesView,
	OnboardingView,
	LadderHeader
}